export const giftback = {
	giftbacks: {
		title: "Giftback campaigns",
		description: "Create and manage your giftback campaigns.",
		createGiftback: "Create giftback",
		searchPlaceholder: "Search by campaign name",
		deleteConfirm: "Are you sure you want to delete the giftback?",
		deleteGiftback: "Delete giftback",
		steps: {
			general: {
				title: "General settings",
			},
			resume: {
				title: "Resume",
			},
		},
		emptyState: {
			title: "There is nothing here yet",
			description: "Adjust the search filter or add a new giftback campaign.",
		},
		buttonsTitle: {
			createAndActivateLater: "Create and activate later",
			createAndActivateNow: "Create and activate giftback",
			saveChanges: "Save changes",
		},
		feedbackerros: {
			selectAtLeastOnePlace: "Select at least one location",
			maxCharactersName: "Maximum of 50 characters",
		},
		form: {
			active: "Activate giftback",
			name: "Campaign's name",
			namePlaceHolder: "Enter the campaign's name",
			minimumConsumptionLabel: "Minimum consumption value",
			minimumConsumptionTooltip:
				"Amount the customer must consume to convert into giftback.",
			percentageLabel: "Percentage",
			percentageTooltip:
				"How much of the customer's consumed value will be gifted back to them.",
			expiresInLabel: "Expire giftback in",
			expiresInTooltip: "Maximum number of days the customer must use the giftback.",
			expiresInPlaceholder: "Select the expiration period for the giftback",
			expiresAtLabel: "Redemption period",
			expiresAtTooltip: "Time the customer will have to enjoy the giftback.",
			expiresAtPlaceholder: "Select the giftback's validity period",
			placeLabel: "Locations participants",
			removeGiftback: "Remove giftback",
			selectAll: "Select all",
			day: "day",
			days: "days",
			week: "week",
			noValidity: "No validity",
			selectAllPlacesDescription:
				"Select the locations where the giftback will be available.",
			shouldConsiderEntranceLabel: "Include entrances in the Giftback calculation",
		},
		tabs: {
			addNewGiftback: "Add new giftback",
		},
	},
	giftbackReport: {
		selectGiftbackLabel: "Campaign",
		selectGiftbackPlaceholder: "Select the campaign(s)",
		table: {
			createdAt: "Created at",
			giftback: "Campaign",
			messagesSent: "SMS sent",
			places: "Places",
			rescues: "Rescues",
			totalValue: "{{ currencySymbol }} value in sales",
			giftbackSent: "Total of giftbacks",
			giftbackValue: "{{ currencySymbol }} giftback redeemed",
			conversionRate: "Conversion rate",
		},
		title: "Rescue report",
		totalizers: {
			quantity: "Created campaigns",
			totalRescues: "Total rescues",
			totalSales: "Total sales using giftback",
			totalSms: "Total SMS created",
		},
	},
	giftbackPowerBi: {
		title: "Giftback Report",
	},
};
